module.exports = __webpack_public_path__ + "img/ALClogo-3-blk.6f536b04.png";